export default __webpack_public_path__ + "static/media/hdl.61e216c1.svg";